import { render, staticRenderFns } from "./custBusinessCouponList.vue?vue&type=template&id=25b29bcb&scoped=true"
import script from "./custBusinessCouponList.vue?vue&type=script&lang=js"
export * from "./custBusinessCouponList.vue?vue&type=script&lang=js"
import style0 from "./custBusinessCouponList.vue?vue&type=style&index=0&id=25b29bcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b29bcb",
  null
  
)

export default component.exports